<template>
  <div>
    <headerTop></headerTop>
    <div class="wrapper" v-if="sellerfqtk">
      <!-- 极配正品 -->
      <!-- <div class="header">
        <img src="@/assets/images/home/logo.png" class="logo" alt="" />
        <div style="position: relative;">
          <div style=" position: absolute;bottom: 0;right: 0; width: 135px;">
            正见 &nbsp; •&nbsp;&nbsp;正心&nbsp; •&nbsp;&nbsp;正品
          </div>
        </div>
      </div> -->
      <div class="content_button">
        <!-- 进度 -->
        <div class="flow">
          <div class="flowcontent">
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-zu5361"></i> -->
                <img src="@/assets/images/refund/组 1615.png" alt="" />
              </div>
              <div>卖家发起退款</div>
            </div>
            <img class="img1" src="@/assets/images/refund/组 1613.png" alt="" />
            <div class="schedule">
              <div>
                <!-- <i class="iconfont icon-a-ziyuan38"></i> -->
                <img src="@/assets/images/refund/组 1609.png" alt="" />
              </div>
              <div class="finish">退款完毕</div>
            </div>
          </div>
        </div>
        <div class="ty">
          <div class="testimony">
            <!-- 表单 -->
            <div class="Sheets">
              <Form
                ref="formValidate"
                :model="formValidate"
                :rules="ruleValidate"
                :label-width="100"
              >
                <Row>
                  <Col>
                    <FormItem label="服务类型:" prop="type">
                      <span style="margin-left: 5px">{{
                        particulars.type == 1 ? '退款' : '退货退款'
                      }}</span>
                      <!-- <span>{{ formValidate.type }}</span> -->
                    </FormItem>
                  </Col>
                  <Col span="12" class="yuanyin">
                    <FormItem label="原因:" prop="reason">
                      <Select
                        :label-in-value="true"
                        @on-change="account"
                        v-model="formValidate.reason"
                      >
                        <Option
                          v-for="item in reasonlist"
                          :key="item.itemValueOne"
                          :value="item.itemValueOne"
                          >{{ item.itemName }}</Option
                        >
                      </Select>
                    </FormItem>
                  </Col>
                </Row>
                <FormItem label="退款说明:" prop="desc">
                  <Input
                    v-model="formValidate.desc"
                    type="textarea"
                    show-word-limit
                    maxlength="200"
                    placeholder="  退款说明"
                  ></Input>
                </FormItem>
                <FormItem label="上传凭证:" prop="name">
                  <div class="Uploadshop">
                    <template>
                      <div
                        class="Anrikshow"
                        v-for="item in certificatelist"
                        :key="item"
                      >
                        <img class="showimg" :src="item" alt="" />
                        <!-- v-show="formValidate.logo" -->
                        <span class="deletelogo" @click="deletelogo(item)"
                          >×</span
                        >
                      </div>
                      <!-- v-show="formValidate.logo && stateaudit.auditStatus == 2" -->
                      <!-- </div> -->
                    </template>
                    <upload
                      :forbid="certificatelist.length == 10 ? true : false"
                      :options="options"
                      @getOssRes="certificate"
                    ></upload>
                    <div class="hint"><span>(最多上传10张图片)</span></div>
                  </div>
                </FormItem>
              </Form>
            </div>
            <div class="tkexplain">
              <!-- 退货单价请与卖家协商后进行填写， -->
              <div>退款不包含运费</div>
            </div>
            <!-- 表格 -->
            <div class="sheet">
              <span class="returns"> 退款商品:</span>
              <vxe-table
                border
                ref="xTable3"
                size="mini"
                align="center"
                resizable
                show-overflow
                :data="tableData3"
                @checkbox-change="selectChangeEvent2"
                :edit-config="{
                  trigger: 'click',
                  mode: 'cell'
                }"
                :edit-rules="validRules"
                :checkbox-config="{ trigger: 'click' }"
                @checkbox-all="selectChangeEventAll"
              >
                <vxe-column width="80" type="checkbox">
                  <!-- <template>
                    <vxe-checkbox
                      type="checkbox"
                      status="primary"
                    ></vxe-checkbox>
                  </template> -->
                </vxe-column>
                <vxe-column
                  field="fullName"
                  title="配件名称"
                  width="220"
                ></vxe-column>
                <vxe-column field="partName" title="发货地" width="180">
                  <template #default="{ row }">
                    <span> {{ row.shipCity }}{{ row.shipStore }} </span>
                  </template>
                </vxe-column>
                <vxe-column
                  field="partNum"
                  title="购买数量"
                  width="100"
                ></vxe-column>
                <!-- <vxe-column
            field="sellPrice"
            title="销售单价"
            width="120"
            :edit-render="{ autofocus: '.vxe-input--inner' }"
          >
            <template #edit="{ row }">
              <vxe-input
                @blur="transfer(row)"
                v-model="row.sellPrice"
                type="text"
              ></vxe-input>
            </template>
          </vxe-column> -->
                <vxe-column
                  field="refundableAmount"
                  title="可退数量"
                  width="100"
                ></vxe-column>
                <vxe-column
                  field="refundNumber"
                  title="退款数量"
                  width="120"
                  :edit-render="{ autofocus: '.vxe-input--inner' }"
                >
                  <template #edit="{ row }">
                    <vxe-input
                      v-model="row.refundNumber"
                      :max="row.refundableAmount"
                      min="1"
                      @change="salesgoods(row)"
                    ></vxe-input>
                  </template>
                </vxe-column>
                <vxe-column
                  field="price"
                  title="退款单价"
                  width="100"
                ></vxe-column>
                <vxe-column
                  style="color: #f62b4e"
                  field="refundAmount"
                  title="退款金额"
                  width="100"
                >
                  <template #default="{ row }">
                    <span class="colorF6">&yen;{{ row.refundAmount }}</span>
                  </template>
                </vxe-column>
              </vxe-table>
            </div>
          </div>

          <!-- 提交 -->
          <div class="present">
            <Button
              class="btn1"
              :loading="loading"
              @click="handleSubmit('formValidate')"
              >提交</Button
            >
          </div>

          <!-- 订单详情 -->
          <div class="indentparticulars">
            <div class="headline">
              <span>订单详情</span>
            </div>
            <div class="content">
              <div class="content_top">
                <Row>
                  <Col span="6">
                    <span>卖家 :&nbsp;</span>
                    <span>{{ particulars.buyShopName }}</span>
                  </Col>
                  <Col span="6">
                    <span>订单编号 :&nbsp;</span>
                    <span class="span1">
                      <!-- <a :href="/orderInformation"></a> -->
                      <router-link
                        rel="opener"
                        :to="{
                          path: '/orderDetails',
                          query: {
                            id: particulars.code,
                            orderId: particulars.id
                          }
                        }"
                        >{{ particulars.code }}</router-link
                      >
                    </span>
                  </Col>
                  <Col span="6">
                    <span>商品金额 :&nbsp;</span>
                    <span style="margin-left: 5px"
                      >&yen;{{ particulars.goodsAmount }}</span
                    >
                  </Col>
                </Row>

                <div style="margin-top: 40px">
                  <Row>
                    <Col span="6">
                      <span>运费 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;&nbsp;{{
                          particulars.freight ? particulars.freight : 0
                        }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>实付款 :&nbsp;</span>
                      <span style="margin-left: 5px"
                        >&yen;{{ particulars.payMoney }}</span
                      >
                    </Col>
                    <Col span="6">
                      <span>数量 :&nbsp;</span>
                      <span style="margin-left: 5px">{{
                        particulars.count
                      }}</span>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <refundwb v-if="sellertkwb" :afterSaleId="afterSaleId"></refundwb>
    </div>
    <div style="height: 80px"></div>
  </div>
</template>

<script>
import refundwb from './components/refundwb.vue'
import headerTop from '@/views/base/common/header-top.vue'
import upload from '@/views/base/uploadify/upload.vue'
import {
  getparticulars,
  salesnumber,
  presentdata,
  disposeInfo,
  entirerefund
} from '@/api/refund/index'
export default {
  components: {
    headerTop,
    upload,
    refundwb
  },
  data() {
    return {
      examine: false,
      sellerfqtk: false, // 卖家发起退款页面
      sellertkwb: false, // 卖家发起退款页面
      afterSaleId: '', // 传输的值
      step: 2,
      details: '', // 详情得id
      refundlabel: '', // 退款原因汉字
      // 表单的数据
      formValidate: {
        type: '', // 类型
        reason: '', // 原因
        logo: '', // 照片
        refundexplain: '', // 退款说明
        uploading: '' // 上传凭证
      },
      reasonlist: [
        {
          itemValueOne: '1',
          itemName: '库存不足'
        }
      ], // 退货原因数据
      // 表单的验证规则
      ruleValidate: {
        reason: [
          {
            required: true,
            message: '请选择退款原因',
            trigger: 'blur'
          }
        ]
      },
      // 第二个表格数据
      tableData3: [
        // {
        //   id: 10001,
        //   partsName: '奔驰水箱散热器A1695001803', // 配件名称
        //   buyquantity: '购买数量', // 购买数量
        //   returnable: '可退数量', // 可退数量
        //   returns: '退货数量', // 退货数量
        //   returnsprice: '退货单价', // 退货单价
        //   returnsmoney: '退货金额' // 退货金额
        // }
      ],
      // 表格的验证规则
      validRules: {
        // ^[1-9]\d*$
        refundNumber: [
          { required: true, message: '请输入退款数量', trigger: 'blur' },
          { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'blur' }
        ]
      },
      ceshi: {
        id: '1',
        name: '大王盖地虎'
      },
      certificatelist: [], //上传的凭证
      particulars: {}, // 订单详情
      returnedlist: [], // 退货商品
      partId: '', //配件id
      refundNumber: '', // 配件的退货数量
      options: {
        size: 5,
        fileType: [
          'png',
          'jpg',
          'jpeg',
          'bmp',
          'gif',
          'webp',
          'psd',
          'svg',
          'tiff'
        ],
        optionbtn8: true
      },
      ceshi12: [],
      loading: false // 转圈
    }
  },
  created() {
    this.orderdetails()
    this.reimbursemoney()
  },
  methods: {
    // 订单详情得数据
    async orderdetails() {
      console.log('订单详情')
      this.details = this.$route.query.details
      // const res = await getparticulars(this.details)
      // const res = await getparticulars('1481092916034785281')
      if (this.details) {
        const res = await getparticulars({ orderId: this.details, type: 2 })
        console.log(res)
        if (res.status) {
          this.sellerfqtk = true
          this.particulars = res.data
          this.tableData3 = res.data.children
          console.log(this.particulars)
        }
      }
    },
    // 退款订单
    async reimbursemoney() {
      this.drawback = this.$route.query.drawback
      if (this.drawback) {
        const res = await disposeInfo(this.drawback + '/1')
        console.log(res)
        if (res.status) {
          this.sellerfqtk = false
          this.sellertkwb = true
          this.afterSaleId = res.data.afterSaleId
        }
      } else {
        return false
      }
    },
    // 提交
    async handleSubmit(name) {
      const data1 = this.$refs.xTable3.getCheckboxRecords()
      console.log(data1)
      if (data1.length == 0) {
        this.$Message.destroy()
        this.$Message.warning('请选择商品')
      } else {
        // this.$refs.formValidate.validate(async (valid) => {
        // if (valid) {
        const $table = this.$refs.xTable3
        const errMap = await $table.validate(data1).catch((errMap) => errMap)
        // if (data1.length == 0) {
        //   this.$Message.destroy()
        //   this.$Message.warning('请选择商品')
        // } else {
        if (errMap) {
          // this.$Message.warning('验证错误')
        } else {
          this.loading = true
          const res = await presentdata({
            reason: this.formValidate.reason, // 售后原因
            remark: this.formValidate.desc, //退款说明
            ordersId: this.particulars.id, //订单id
            type: 1, //售后类型(1退款、2退货、3退货退款)
            imagesUrl: this.certificatelist, //退货图片地址(多个用英文逗号隔开)
            refundedGoodsList: this.partIdlist, //退款商品
            content: this.refundlabel,
            role: '2'
          })
          console.log(res)
          if (res.status) {
            this.loading = false
            this.sellertkwb = true
            this.afterSaleId = res.data
            this.sellerfqtk = false
            this.$Message.success('提交订单成功')
          } else {
            this.loading = false
          }
          // else {
          //   this.$Message.error(res.message)
          // }
          // this.$router.push({
          //   path: '/reimburse',
          //   query: { searchContent: this.ceshi }
          // })
        }
        // }
        // }
        // })
      }
    },
    // 取消
    // handleReset(name) {
    //   this.$refs[name].resetFields()
    // },
    // 表单选择多选框
    selectChangeEvent2({ checked, records }) {
      // console.log(checked ? '勾选事件' : '取消事件', records)
      console.log(records)
      this.partIdlist = records
      console.log(this.partIdlist)
      this.partIdlist = this.partIdlist.map((item) => {
        return {
          partId: item.partId,
          refundNumber: item.refundNumber,
          refundAmount: item.refundAmount,
          storeId: item.storeId
        }
      })
      console.log(this.partIdlist)
    },
    // 删除凭证
    deletelogo(file) {
      console.log(file)
      this.certificatelist = this.certificatelist.filter((item) => {
        return item !== file
      })
      console.log(this.certificatelist)
    },
    async salesgoods(row) {
      console.log(row)
      this.partId = row.partId
      this.refundNumber = row.refundNumber
      const $table = this.$refs.xTable3
      const errMap = await $table.validate(row).catch((errMap) => errMap)
      if (errMap) {
        // this.$Message.destroy()
        // this.$Message.error('请输入正整数')
      } else {
        if (this.refundNumber) {
          const res = await salesnumber({
            orderId: this.particulars.id, // 订单id
            partId: this.partId, // 商品id
            refundNumber: this.refundNumber, // 退款数量
            storeId: row.storeId
          })
          console.log(res)
          row.refundAmount = res.data
          const data = this.$refs.xTable3.getCheckboxRecords()
          console.log(data)
          this.partIdlist = data
          console.log(this.partIdlist)
          this.partIdlist = this.partIdlist.map((item) => {
            return {
              partId: item.partId,
              refundNumber: item.refundNumber,
              refundAmount: item.refundAmount,
              storeId: item.storeId
            }
          })
        }
      }
    },
    // 上传凭证
    certificate(res, b) {
      console.log(res) // 图片
      console.log(b) // 名字
      console.log(this.certificatelist) // 接受的list
      if (this.certificatelist.length < 10) {
        this.certificatelist.push(res.url)
      } else {
        return false
      }
    },
    // 退款原因name
    account(a) {
      this.refundlabel = a.label
    },
    // vxe自带的全选
    async selectChangeEventAll({ checked, records }) {
      if (checked) {
        const res = await entirerefund(this.details + '/2')
        this.tableData3 = res.data.list
        this.partIdlist = this.tableData3.map((item) => {
          return {
            partId: item.partId,
            refundNumber: item.refundNumber,
            refundAmount: item.refundAmount,
            storeId: item.storeId
          }
        })
        this.$refs.xTable3.setCheckboxRow(this.tableData3, true)
      } else {
        this.$refs.xTable3.setCheckboxRow(this.tableData3, false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
